export default __webpack_public_path__ + "static/media/book1.8ae8e7ff.jpg";